import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthGuardData, createAuthGuard} from 'keycloak-angular';
import {inject} from '@angular/core';

const isAuthenticated = async (
  _: ActivatedRouteSnapshot,
  __: RouterStateSnapshot,
  authData: AuthGuardData
) => {
  const router = inject(Router);
  return authData.authenticated ? true : router.parseUrl('/');
}

const redirectAuthenticatedUsers = async (
  _: ActivatedRouteSnapshot,
  __: RouterStateSnapshot,
  authData: AuthGuardData
) => {
  const router = inject(Router);
  return authData.authenticated ? router.parseUrl('/overview') : true;
}

export const isAuthenticatedGuard = createAuthGuard<CanActivateFn>(isAuthenticated);
export const redirectAuthenticatedUsersGuard = createAuthGuard<CanActivateFn>(redirectAuthenticatedUsers);
